import React from 'react';
import PropTypes from 'prop-types';
import EditModal from '../../common/modal/EditModal';
import RowDisplay from '../../common/RowDisplay';
import DateOfBirthForm from './DateOfBirthForm';
import formatDate from '@unite-us/client-utils/dist/utils/dates/formatDate';
import { useAppContext } from '../../../context/context';
import { get } from 'lodash';
function DateOfBirthDisplay(props) {
  var contact = props.contact;
  var _useAppContext = useAppContext(),
    fieldsConfig = _useAppContext.state.fieldsConfig;
  var editSection = /*#__PURE__*/React.createElement(EditModal, {
    header: "Edit Date of Birth",
    size: "normal",
    formName: "edit-date-of-birth",
    editButtonId: "edit-dob-btn",
    id: "edit-dob-modal",
    showEdit: get(fieldsConfig, 'dateOfBirthSection.showEdit')
  }, /*#__PURE__*/React.createElement(DateOfBirthForm, {
    contact: contact
  }));
  return /*#__PURE__*/React.createElement(RowDisplay, {
    editSection: editSection,
    label: "Date of Birth"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-sm-12"
  }, /*#__PURE__*/React.createElement("p", {
    "data-test-element": "dob-display",
    className: "profile-value"
  }, formatDate(contact.date_of_birth))));
}
DateOfBirthDisplay.propTypes = {
  contact: PropTypes.object.isRequired
};
export default DateOfBirthDisplay;
//# sourceMappingURL=DateOfBirthDisplay.js.map